/**
 * Utility for auto-generating tag keys and values from text inputs.
 */

const STOP_WORDS = new Set([
  'which', 'what', 'where', 'how', 'are', 'is', 'do', 'you', 'your', 
  'the', 'a', 'an', 'in', 'of', 'for', 'to', 'with', 'on', 'at'
]);

export const generateTagKey = (text) => {
  if (!text) return '';
  
  // Clean text: lowercase, remove non-alphanumeric (except spaces)
  const cleanText = text.toLowerCase().replace(/[^a-z0-9\s]/g, '');
  
  // Split and filter stop words
  const words = cleanText.split(/\s+/).filter(word => word.length > 0 && !STOP_WORDS.has(word));
  
  // Take first 3 significant words
  return words.slice(0, 3).join('_');
};

export const generateTagValue = (text) => {
  if (!text) return '';
  
  // Lowercase, replace spaces with underscores, remove special characters
  return text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
};